<form [formGroup]="form">
  <app-modal-container [displayFooter]="true" xmlns="http://www.w3.org/1999/html" class="app-issue-report-field-selector">
    <span class="modal-header-content">
      {{ 'header_manual_audit_issues_export' | translate }}
    </span>

    <div class="modal-body-content">
      <h3>{{ 'manual_audit_issues_export_title' | translate: modalInputData.data.issueCount }}</h3>
      <p class="column-description">{{ 'manual_audit_issues_export_description_col_description' | translate }}</p>

      <div class="row margin-bottom">
        <div class="col-12">
          <h4 class="mb-2">{{ 'manual_audit_format_columns_label' | translate }}</h4>
        </div>
        <div class="col-12 mb-1">
          <input
            type="radio"
            [id]="$formatColumns.singleDescriptionColumn"
            [value]="$formatColumns.singleDescriptionColumn"
            [formControlName]="ManualAuditQuery.formatColumns"
            class="me-2"
          />
          <label [for]="$formatColumns.singleDescriptionColumn">{{
            'manual_audit_format_option_single_description_column' | translate
          }}</label>
        </div>
        <div class="col-12 mb-1">
          <input
            type="radio"
            [id]="$formatColumns.separateColumns"
            [value]="$formatColumns.separateColumns"
            [formControlName]="ManualAuditQuery.formatColumns"
            class="me-2"
            data-test-id="separate-columns-option"
          />
          <label [for]="$formatColumns.separateColumns">{{ 'manual_audit_format_option_separate_columns' | translate }}</label
          ><br />
        </div>
      </div>

      <div class="row margin-bottom">
        <div class="col-md-12 d-flex">
          <div>
            <button
              class="btn btn-link btn-flat text-underline fw-bold no-padding margin-right-md"
              type="button"
              (click)="selectAllColumns()"
              data-test-id="select-all"
            >
              {{ 'label_select_all' | translate }}
            </button>
          </div>
          <div>
            <button
              class="btn btn-link btn-flat text-underline fw-bold no-padding"
              type="button"
              data-test-id="unselect-all"
              (click)="unselectAllColumns()"
            >
              {{ 'label_unselect_all' | translate }}
            </button>
          </div>
        </div>
      </div>

      <div class="row" data-test-id="filter-options">
        <div class="col-6">
          @for (ctrlDef of firstColumnDescriptionFields$ | async; track ctrlDef.name) {
            <div>
              <label class="label d-flex align-items-center margin-bottom-xs">
                <input type="checkbox" [formControlName]="ctrlDef.name" [id]="ctrlDef.name" (change)="selectedChange(ctrlDef)" />
                <span class="checkbox-label">{{ ctrlDef.labelKey ?? 'issue_field_' + ctrlDef.name | translate }}</span>
              </label>
            </div>
          }
        </div>
        <div class="col-6">
          @for (ctrlDef of secondColumnDescriptionFields$ | async; track ctrlDef.name) {
            <div>
              <label class="label d-flex align-items-center margin-bottom-xs">
                <input type="checkbox" [formControlName]="ctrlDef.name" [id]="ctrlDef.name" (change)="selectedChange(ctrlDef)" />
                <span class="checkbox-label">{{ ctrlDef.labelKey ?? 'issue_field_' + ctrlDef.name | translate }}</span>
              </label>
            </div>
          }
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end modal-footer-content">
      <button class="btn btn-outline-primary margin-left-md" (click)="onClose()" data-test-id="modal-close">
        {{ 'label_close' | translate }}
      </button>
      <button
        class="btn btn-primary margin-left-md"
        type="submit"
        [disabled]="currentSelectedCount === 0"
        data-test-id="modal-export"
        (click)="onExport()"
      >
        {{ 'btn_manual_audit_issues_export' | translate }}
      </button>
    </div>
  </app-modal-container>
</form>
